import * as React from "react";
import { forwardRef } from "react";
const SvgMinusCircle = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { clipRule: "evenodd", d: "M3.813 3.813a8.696 8.696 0 0 0 0 12.374 8.696 8.696 0 0 0 12.374 0 8.696 8.696 0 0 0 0-12.374 8.696 8.696 0 0 0-12.374 0Zm11.667 6.894H4.52V9.293h10.96v1.414Z" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.01, clipRule: "evenodd", d: "m13.375 14.375-7.75-7.75 1-1 7.75 7.75-1 1Z" }));
const ForwardRef = forwardRef(SvgMinusCircle);
export { ForwardRef as ReactComponent };
